import { RandomGenerator } from '../../../test-utils';
var ExtendedSendingDomainBuilder = /** @class */ (function () {
    function ExtendedSendingDomainBuilder() {
        this.sendingDomain = {
            id: RandomGenerator.id(),
            domain: RandomGenerator.randomString() + '.com',
            default: false,
            dnsRecords: [],
            valid: false,
        };
    }
    ExtendedSendingDomainBuilder.prototype.withId = function (id) {
        this.sendingDomain.id = id;
        return this;
    };
    ExtendedSendingDomainBuilder.prototype.withDomainName = function (domainName) {
        this.sendingDomain.domain = domainName;
        return this;
    };
    ExtendedSendingDomainBuilder.prototype.withDefault = function (isDefault) {
        this.sendingDomain.default = isDefault;
        return this;
    };
    ExtendedSendingDomainBuilder.prototype.withDnsRecords = function (dnsRecords) {
        this.sendingDomain.dnsRecords = dnsRecords;
        return this;
    };
    ExtendedSendingDomainBuilder.prototype.withValid = function (valid) {
        this.sendingDomain.valid = valid;
        return this;
    };
    ExtendedSendingDomainBuilder.prototype.build = function () {
        return this.sendingDomain;
    };
    return ExtendedSendingDomainBuilder;
}());
export { ExtendedSendingDomainBuilder };
//# sourceMappingURL=extended-sending-domain-builder.js.map